"use client";

import { useState } from "react";

import NextImage from "next/image";

export type SearchResultsProperties = {
  imageAlt?: string | undefined;
  imageSrc?: string | undefined;
};
export const SearchResults = ({
  imageSrc,
  imageAlt,
}: SearchResultsProperties) => {
  const [apiStatus] = useState("");
  const [results] = useState([]);

  return (
    <div className="relative min-h-64">
      <div aria-live="polite" className="sr-only">
        {apiStatus}
      </div>

      {results.length === 0 && imageAlt && imageSrc && (
        <div
          className="
            relative mt-4 h-64

            md:mt-6
          "
        >
          <NextImage
            alt={imageAlt}
            className="mx-auto object-scale-down"
            fill
            src={imageSrc}
          />
        </div>
      )}

      {results.length > 0 && <ul>Results</ul>}
    </div>
  );
};
